import { connect } from 'react-redux';
import SearchForm from '../components/SearchForm';
import { setModalSearchBoxState } from '../actions/SearchBoxAction';

const mapStateToProps = (state) => ({
    breakpoint: state.breakpointReducer,
    modalSearchBoxIsOpen: state.search.modalSearchBoxIsOpen,
});

const mapDispatchToProps = (dispatch) => ({
    setModalSearchBoxState: (isOpen = false) => {
        dispatch(setModalSearchBoxState(isOpen));
    },
});


const SearchFormContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SearchForm);

export default SearchFormContainer;
